<template>
  <div class="page__info">
    <div class="page__info-text">
      <h3 v-html="$t(`${namespace}.titleHowToRequest`)" class="mb-1" />
      <p v-html="$t(`${namespace}.textHowToRequest`)" />
      <p v-html="$t(`${namespace}.textHowToRequestExtra`)" />
    </div>

    <div class="page__info-button">
      <v-btn round depressed color="accent" @click="requestToken">
        {{ $t(`${namespace}.btnRequest`) }}
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HowToRequestInfo',
  data () {
    return {
      namespace: 'Views.TokenRequestPage'
    }
  },
  methods: {
    requestToken () {
      this.$emit('showRequestTokenForm')
    }
  }
}
</script>
<style lang="scss" scoped>
.page__info {
  padding: 24px;

  h3,
  p {
    font-size: 14px;
  }

  .page__info-button {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
